import { render, staticRenderFns } from "./TopUpHistory.vue?vue&type=template&id=3daf2514"
import script from "./TopUpHistory.vue?vue&type=script&lang=ts"
export * from "./TopUpHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports